import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { AppErrorBoundary } from "@/app/AppErrorBoundary";
import { AppRoutes } from "@/app/routes/AppRoutes";

export function App() {
  const { t } = useTranslation("common");

  return (
    <AppErrorBoundary>
      <Helmet
        defaultTitle={t("app.defaultDocumentTitle")}
        titleTemplate={t("app.titleTemplate")}
      />
      <AppRoutes />
    </AppErrorBoundary>
  );
}
